<template>
  <keep-alive>
    <v-container
      fluid
      style="height: 100%; padding:0px; min-height: inherit; max-width: 1500px"
      class="d-flex flex-column"
    >
      <!-- Success Notifications -->
      <v-alert
        v-for="notification in notifications"
        :key="'success-' + notification"
        dismissible
        type="success"
        style="margin-left: 100px; margin-right: 80px;"
      >
        {{ notification }}
      </v-alert>

      <!-- Error Notifications -->
      <v-alert
        v-for="notification in errorNotifications"
        :key="'error-' + notification"
        dismissible
        type="error"
        style="margin-left: 100px; margin-right: 80px;"
      >
        {{ notification }}
      </v-alert>

      <!-- Main Agency Home Content -->
      <template v-if="profile.type === 'Agency'">
        <div
          class="d-flex flex-row"
          style="height: 100%; padding:0px; min-height: inherit; max-width: 1500px"
        >
          <agency-left-section class="hidden-sm-and-down" />
          <feed-section />
          <agency-right-section class="hidden-md-and-down" />
        </div>

        <!-- Dialogs (conditionally rendered) -->
        <agency-complete-profile-dialog
          v-if="completeProfileDialog"
          :dialog="completeProfileDialog"
          :onClose="onCloseCompleteProfileDialog"
        />
        <agency-causes-dialog
          v-if="causeDialog"
          :dialog="causeDialog"
          :onClose="onCloseCausesDialog"
        />
        <agency-add-links
          v-if="urlDialog"
          :dialog="urlDialog"
          :onClose="onCloseURLDialog"
        />
        <agency-congrates-dialog
          v-if="congratsDialog"
          :dialog="congratsDialog"
          :onClose="onCloseCongratsDialog"
        />
      </template>

      <!-- Not Found for non-Agency profiles -->
      <template v-else>
        <not-found />
      </template>

      <!-- Snackbar for error messages -->
      <v-snackbar v-model="snackbar">
        {{ errorMessage }}
      </v-snackbar>
    </v-container>
  </keep-alive>
</template>
<script>
import { mapActions, mapState } from "vuex";
// import PhoneVerificationDialog from "@/components/common/PhoneVerificationDialog.vue";
import FeedSection from "../event_feeds/FeedSection.vue";
import AgencyLeftSection from "./AgencyLeftSection.vue";
import AgencyRightSection from "./AgencyRightSection.vue";
import AgencyCompleteProfileDialog from "./complete_profile_dialog/AgencyCompleteProfileDialog.vue";
import AgencyCausesDialog from "./complete_profile_dialog/AgencyCausesDialog.vue";
import AgencyAddLinks from "./complete_profile_dialog/AgencyAddLinks.vue";
import AgencyCongratesDialog from "./complete_profile_dialog/AgencyCongratesDialog.vue";
import notFound from "../NotFound.vue";
export default {
  components: {
    AgencyLeftSection,
    AgencyRightSection,
    FeedSection,
    // PhoneVerificationDialog,
    AgencyCompleteProfileDialog,
    AgencyCausesDialog,
    AgencyAddLinks,
    AgencyCongratesDialog,
    notFound
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      snackbar: false,
      notifications: [],
      errorNotifications: [],
      verifyPhoneDialog: false,
      completeProfileDialog: false,
      causeDialog: false,
      congratsDialog: false,
      urlDialog: false,
      passedVerification: false
    };
  },
  methods: {
    ...mapActions("event", {
      fetchAllEvents: "fetchAllEvents"
    }),
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbar = true;
    },
    checkPhoneVerified() {
      if (!this.profile._id || this.passedVerification) return;
      // if (!this.profile.phone_verified) {
      //   if (!this.profile.phone_verification_code) {
      //     //implement send verification code
      //     console.log("implement send verification code");
      //   }
      //   setTimeout(() => {
      //     this.verifyPhoneDialog = true;
      //   }, 500);
      //   return;
      // }
      this.checkCompletedProfile();
    },
    onCloseVerify() {
      this.passedVerification = true;
      this.onCloseAllDialog();
      this.checkCompletedProfile();
    },
    checkCompletedProfile() {
      if (
        this.profile &&
        this.profile._id &&
        (!this.profile.image ||
          !this.profile.who_we_are ||
          !this.profile.what_we_do)
      ) {
        setTimeout(() => {
          this.completeProfileDialog = true;
        }, 500);
        return;
      }
      this.checkCauses();
    },
    onCloseAllDialog() {
      this.verifyPhoneDialog = false;
      this.completeProfileDialog = false;
      this.causeDialog = false;
      this.urlDialog = false;
      this.congratsDialog = false;
    },
    onCloseCompleteProfileDialog() {
      this.onCloseAllDialog();
      this.checkCauses();
    },
    checkCauses() {
      if (
        this.profile &&
        this.profile.causes &&
        this.profile.causes.length == 0
      ) {
        setTimeout(() => {
          this.causeDialog = true;
        }, 500);
      } else {
        this.checkUrls();
      }
    },
    onCloseCausesDialog() {
      this.onCloseAllDialog();
      this.checkUrls();
    },
    checkUrls() {
      if (this.profile && !this.profile.website) {
        setTimeout(() => {
          this.urlDialog = true;
        }, 500);
      } else {
        this.showCongratsDialog();
      }
    },
    onCloseURLDialog() {
      this.onCloseAllDialog();
      this.showCongratsDialog();
    },
    showCongratsDialog() {
      if (
        this.profile.phone_verified &&
        this.profile.image &&
        this.profile.who_we_are &&
        this.profile.what_we_do &&
        this.profile.causes.length != 0 &&
        this.profile.website
      ) {
        if (!this.profile.email_verified) {
          setTimeout(() => {
            this.congratsDialog = true;
          }, 500);
        }
      }
    },
    onCloseCongratsDialog() {
      this.onCloseAllDialog();
      this.$router.push({ name: "volunteer-profile" });
    },
    checkApproved() {
      if (
        this.profile.status === "Pending" ||
        this.profile.status === "Rejected"
      ) {
        this.$router.push({
          name: "agency-approval"
        });
      }
    }
  },
  computed: {
    ...mapState("auth", {
      profile: "profile"
    })
  },
  watch: {
    profile: function(newValue) {
      // if (this.profile) {
      //   this.checkApproved();
      // }
      if (this.$route.query.welcome && newValue) {
        this.checkPhoneVerified();
      }
      // find if there is any item stored in local storage in the name of notifications_received
      // if there is, then get the value and set it to the store
      const notifications_received = localStorage.getItem(
        "notifications_received"
      );
      console.log("notifications_received", notifications_received);
      if (notifications_received) {
        // then for each item in the array, call store action addMessageFromFCM
        JSON.parse(notifications_received).forEach(notification => {
          this.$store.dispatch("chat/addMessageFromFCM", notification);
        });
        // then remove the item from local storage
        localStorage.removeItem("notifications_received");
      }
    }
  },
  mounted() {
    if (this.$route.query.welcome && this.profile) {
      this.checkPhoneVerified();
    }
    // if (this.profile) {
    //   this.checkApproved();
    // }
    this.notifications = this.$route.params.notifications;
    this.errorNotifications = this.$route.params.error;
  }
};
</script>
<style scoped></style>
